/**
 * @generated SignedSource<<91e5468310cecd31b1410b4543c9e779>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ApprovalStyle = "AUTOMATIC" | "MANUAL" | "%future added value";
export type UpdateCapabilityInput = {
  approvalStyle?: ApprovalStyle | null | undefined;
  description?: string | null | undefined;
  id: any;
  integrationId?: any | null | undefined;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
  parametersSchema?: any | null | undefined;
  targetConfig?: any | null | undefined;
};
export type EditCapabilityDialogUpdateMutation$variables = {
  input: UpdateCapabilityInput;
};
export type EditCapabilityDialogUpdateMutation$data = {
  readonly updateCapability: {
    readonly capability: {
      readonly approvalStyle: ApprovalStyle;
      readonly description: string;
      readonly id: any;
      readonly name: string;
      readonly parametersSchema: any;
    } | null | undefined;
    readonly error: string | null | undefined;
  };
};
export type EditCapabilityDialogUpdateMutation = {
  response: EditCapabilityDialogUpdateMutation$data;
  variables: EditCapabilityDialogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCapabilityPayload",
    "kind": "LinkedField",
    "name": "updateCapability",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLCapability",
        "kind": "LinkedField",
        "name": "capability",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "approvalStyle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parametersSchema",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditCapabilityDialogUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditCapabilityDialogUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8f3ea475c3b48faf9503edb31fd301ff",
    "id": null,
    "metadata": {},
    "name": "EditCapabilityDialogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation EditCapabilityDialogUpdateMutation(\n  $input: UpdateCapabilityInput!\n) {\n  updateCapability(input: $input) {\n    capability {\n      id\n      name\n      description\n      approvalStyle\n      parametersSchema\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "737f9fcba4dac1c04dff365f06948a39";

export default node;
